import { Subject } from 'rxjs';
import { Quantity,Preset } from './units-datatypes';

export const MockUnitsService = {

    unitChangeAnnounced : (new Subject<{quantityName:string;fromUnit:string;toUnit:string}>()).asObservable(),

    setAsPreset(preset:string,silent?:boolean) {
    },

    getUnitsForQuantity(quantityName: string): string[] {
      return [];
    },

    getSelectedUnitForQuantity(quantityName: string) {
      return '°C';
    },

    setUnitForQuantity(quantityName: string, unit: string, intialisingCustomPreset?:boolean) {
    },

    convertFromSIForQuantity(quantityName: string, value: number):number {
      return value*10;
    },

    convertToSIForQuantity(quantityName: string, value: number) {
      return value/10;
    }

  }

  export const MockMsalService = {

  }

  export const MockLoginService = {
    getAccount(){
      return {};
    }
  }
